import axios from 'axios';

export const getImageById = async (ImageId: string) => {
  const { $adminApiClient, $adminGetAccessData } = useNuxtApp()
  const tokenData = await $adminGetAccessData();
  try {
    const operationName = "getMedia get /media/" + ImageId;

    const response = await $adminApiClient.invoke(operationName, {});
    if (response && response?.data) {
      return response?.data?.data.url;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}



export const fetchCustomConfig = async () => {
  const { $adminGetAccessData, $adminApiClient } = useNuxtApp();
  const { sessionContext } = useSessionContext();
  await $adminGetAccessData();

  try {
    const operationName: string =
      "searchSystemConfig get /_action/system-config?domain=NetzpBlog6.config"; // Make sure this matches your API client library setup
    const resAll = await $adminApiClient.invoke(operationName);

    return resAll;
  } catch (error) {
    console.error("Error fetching System Config:", error);
    throw error;
  }
};